
const API_CONFIG = {
    getCode: "/app/login/getCode", // 获取验证码
    userRegister: "/app/login/register", //   注册
    getSmsCode: "/app/login/getSmsCode", // 获取短信验证码
    setAPassword: "/app/login/setAPassword", // 设置密码
    userLogin: "/accountAndPassword/login", // 登录



    atlasList: "/system/atlas/list", // 地图列表
    folderList: "/system/folder/list", // 文件夹列表
    layerList: "/system/layer/list", // 图层列表
    descriptionList: "/system/description/list", // 描述列表



    userList: "/system/user/list", // 用户列表
    userApiList: "/system/user/api/list", // 用户接口列表

    codeList: "/system/atlas/code/list",  // 地图编码列表

    userAuthorityList: "/system/user/code/list", // 用户权限列表


    configList: "/system/config/list", // 获取配置列表

    updateConfig: "/system/config", // 修改配置



    addAtlas: "/system/atlas", // 新增地图
    addFolder: "/system/folder", // 新增文件夹
    addLayer: "/system/layer/add", // 新增图层
    addDescription: "/system/description/appAdd", // 新增描述

    addUserAuthority: "/system/user/code", // 新增用户权限





    delAtlas: "/system/atlas/ids", // 删除地图
    delFolder: "/system/folder/ids", // 删除文件夹
    delLayer: "/system/layer/ids", // 删除图层
    delDescription: "/system/description/ids", // 删除描述

    delUserAuthority: "/system/user/code/api/delId", // 删除用户权限





    getAtlasInfo: "/system/atlas/", // 获取地图详情
    getFolderInfo: "/system/folder/", // 获取文件夹详情
    getLayerInfo: "/system/layer/", // 获取图层详情
    getDescriptionInfo: "/system/atlas/atlas/app/details/name", // 获取描述详情

    getUserJurisdiction: "/system/user/code/get/user/jurisdiction", // 获取用户权限

    getDescriptionCode: "/system/description/code", // 获取描述列表根据编码



    updateFolder: "/system/folder", // 修改文件夹
    updateLayer: "/system/layer", // 修改图层
    updateAtlas: "/system/atlas", // 修改地图
    updateDescription: "/system/description", // 修改描述

    updateUserAuthority: "/system/user/code", // 新增用户权限

    updateUserInfo: "/app/login/updateAppUserInfo",// 修改用户信息





    moveAtlas: "/system/atlas/move", // 移动地图
    copyAtlas: "/system/atlas/copy/atlas", // 复制地图




}


export default API_CONFIG;